export const ClientBasedConfigLayoutConstants = {
  LOGIN_SECTION_LEFT_BRANDING_SECTION_RIGHT:
    'LOGIN_SECTION_LEFT_BRANDING_SECTION_RIGHT',
  LOGIN_SECTION_RIGHT_BRANDING_SECTION_LEFT:
    'LOGIN_SECTION_RIGHT_BRANDING_SECTION_LEFT',
  ONLY_LOGIN_SECTION: 'ONLY_LOGIN_SECTION'
};

export const CLIENT_ID = 'client_id';
export const AUTH_CLIENT_ID = 'auth_client_id';
export const CALL_BACK_URL = 'call_back_url';
export const FALL_BACK_URL = 'fall_back_url';
export const AUTH_CODE = 'auth_code';
export const INVITE_CODE = 'invite_code';

export const LOGIN_MODE = 'mode';
export const AUTO_REGISTER = 'auto_register';
export const WINDOW_MODE = 'WINDOW_MODE';

export const excludeQueryParams = [
  AUTO_REGISTER,
  WINDOW_MODE,
  LOGIN_MODE,
  CLIENT_ID,
  CALL_BACK_URL,
  FALL_BACK_URL,
  AUTH_CLIENT_ID
];
